module.exports = __webpack_public_path__ + "img/debt.9e831543.svg";